export const parseError = (error) => {
  // Handle policy generation errors (JSON)
  if (error.response?.data?.errors) {
    return {
      code: error.response.data.errors[0].code,
      message: error.response.data.errors[0].message,
      details: error.response.data.errors,
    }
  }

  // Handle S3-style XML errors
  if (error.response?.headers['content-type']?.includes('application/xml')) {
    const parser = new DOMParser()
    const xmlDoc = parser.parseFromString(error.response.data, 'text/xml')
    const code = xmlDoc.querySelector('Code')?.textContent
    const message = xmlDoc.querySelector('Message')?.textContent

    return {
      code,
      message,
      details: error.response.data,
    }
  }

  // Handle network or unexpected errors
  return {
    code: 'UNKNOWN_ERROR',
    message: 'An unexpected error occurred',
    details: error,
  }
}

export const parseBackendError = (errorCode) => {
  if (errorCode === 'conversion_failed') {
    return {
      code: 'CONVERSION_ERROR',
      message: 'failed to process',
      details: null,
    }
  }

  if (errorCode === 'password_required') {
    return {
      code: 'PASSWORD_REQUIRED',
      message: 'password required',
      details: null,
    }
  }

  if (errorCode === 'password_mismatched') {
    return {
      code: 'PASSWORD_MISMATCHED',
      message: 'Password does not match. Try again.',
      details: null,
    }
  }

  return {
    code: 'UNKNOWN_ERROR',
    message: 'An unexpected error occurred',
    details: error,
  }
}
